import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=71d3eaba&scoped=true&"
import script from "./NewsArticle.vue?vue&type=script&lang=js&"
export * from "./NewsArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d3eaba",
  null
  
)

export default component.exports